/** Official AchieveApex brand files. */
export const BRAND_LOGO = '/images/achieve-apex-logo.png'
export const BRAND_LOGO_WHITE = '/images/achieve-apex-logo-white.png'
export const BRAND_ICON = '/images/achieveapex-icon.png'

/**
 * Use this for next/image src. Do not append query strings:
 * Amplify's `/_next/image` optimizer 404s on `?v=` in production.
 */
export const brandAsset = (path: string) => path
